import * as React from "react";
import "./index.css";

const NoMatchPage = (props) => {
  props.updateValue({ themeSelected: true });
  return <div className="nomatch">404 - Not found</div>;
};
export default NoMatchPage;
